import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { memo } from 'react';
import { Select } from '@outdoor-voices/ui';
import { useContext } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { CONTACT_URL, ROOT_URL } from './constants';
import { OVContext } from '../../../utils/OVContext';
import css from './Nav.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Nav = function Nav(_ref) {
  var categories = _ref.categories,
      fetching = _ref.fetching;

  var _useContext = useContext(OVContext),
      tabletSmall = _useContext.tabletSmall;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var history = useHistory();
  var contactON = pathname === CONTACT_URL;
  var QA = 'Quick Actions';
  var CONTACT = 'Contact Us';
  var categoriesMapped = categories.map(function (_ref2) {
    var id = _ref2.id,
        slug = _ref2.slug,
        title = _ref2.title;
    return {
      id: id,
      label: title,
      value: "".concat(ROOT_URL, "-").concat(slug)
    };
  });
  var options = [{
    label: QA,
    value: ROOT_URL
  }].concat(categoriesMapped).concat([{
    label: CONTACT,
    value: CONTACT_URL
  }]);

  var onMobileNavChange = function onMobileNavChange(_ref3) {
    var value = _ref3.target.value;
    history.push(value);
  };

  return /*#__PURE__*/_jsxs("nav", {
    className: css.nav,
    children: [!tabletSmall && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Link, {
        className: cc([css.link, css.quickActions, _defineProperty({}, css.on, pathname === ROOT_URL)]),
        to: ROOT_URL,
        children: QA
      }), /*#__PURE__*/_jsx("div", {
        className: css.faqsTitle,
        children: "FAQs"
      }), fetching && /*#__PURE__*/_jsx("ul", {
        className: css.list,
        "aria-busy": "true",
        children: new Array(10).fill().map(function (_, idx) {
          return /*#__PURE__*/_jsx("li", {
            className: css.item,
            children: /*#__PURE__*/_jsx("div", {
              className: css.loading,
              children: "\xA0"
            })
          }, idx);
        })
      }), !fetching && /*#__PURE__*/_jsx("ul", {
        className: css.list,
        children: categoriesMapped.map(function (_ref5) {
          var id = _ref5.id,
              value = _ref5.value,
              label = _ref5.label;
          var on = pathname === value;
          return /*#__PURE__*/_jsx("li", {
            className: css.item,
            children: /*#__PURE__*/_jsx(Link, {
              className: cc([css.link, _defineProperty({}, css.on, on)]),
              to: value,
              children: label
            }, id)
          }, id);
        })
      }), /*#__PURE__*/_jsx(Link, {
        className: cc([css.link, css.contactUs, _defineProperty({}, css.on, contactON)]),
        to: CONTACT_URL,
        children: CONTACT
      })]
    }), tabletSmall && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: css.mobileTitle,
        children: "Topics"
      }), /*#__PURE__*/_jsx("div", {
        className: css.mobileSubtitle,
        children: "Tap to view the full menu."
      }), /*#__PURE__*/_jsx(Select, {
        label: "Tap to view the full menu.",
        hideLabel: true,
        id: "help-center-nav",
        name: "help-center-nav",
        options: options,
        onChange: onMobileNavChange,
        placeholder: "Select a topic",
        value: pathname === "".concat(ROOT_URL, "-search") ? null : pathname
      })]
    })]
  });
};

Nav.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string,
    title: PropTypes.string
  })),
  current: PropTypes.string,
  fetching: PropTypes.bool
};
export default /*#__PURE__*/memo(Nav);